import React from 'react';
import CustModal from '../common/custmodal/CustModal';
import OutlinedCloseIcon from '../svgIcons/OtlinedCloseIcon';
import styles from './StaffManagement.module.css';
import MailIcon from '../svgIcons/MailIcon';

interface PropertyData {
    id: string;
    name: string;
    roleName: string;
    email: string;
    assignedProperties: string[];
}

interface PropertiesModalProps {
    isOpen: boolean;
    onClose: () => void;
    propertyData: PropertyData | null;
}

const PropertiesModal: React.FC<PropertiesModalProps> = ({ isOpen, onClose, propertyData }) => {
    if (!propertyData) return null;

    return (
        <CustModal
            open={isOpen}
            className="custom-import-modal"
            bodyData={
                <div className={styles.propertiesModal}>
                    <div className={styles.modalInnerContainer}>
                        <div className={styles.modalHeaderContainer}>
                            <div className={styles.headerContent}>
                                <div className={styles.staffAvatar}>
                                    <span>{propertyData.name.charAt(0).toUpperCase()}</span>
                                </div>
                                <div className={styles.headerText}>
                                    <h3>{propertyData.name}</h3>
                                    <p className={styles.staffRole}>{propertyData.roleName}</p>
                                    <div className={styles.infoCard}>
                                        <MailIcon />
                                        <div className={styles.infoContent}>
                                            <span>{propertyData.email}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.close} onClick={onClose}>
                                <OutlinedCloseIcon />
                            </div>
                        </div>

                        {/* <div className={styles.staffInfoSection}>
                            <div className={styles.infoCard}>
                                <div className={styles.infoContent}>
                                    <span>{propertyData.email}</span>
                                </div>
                            </div>
                        </div> */}

                        <div className={styles.propertiesSection}>
                            <div className={styles.sectionHeader}>
                                <h4>📋 Assigned Properties</h4>
                                <span className={styles.propertyCount}>
                                    {propertyData.assignedProperties.length} {propertyData.assignedProperties.length === 1 ? 'Property' : 'Properties'}
                                </span>
                            </div>

                            <div className={styles.propertiesList}>
                                {propertyData.assignedProperties.length > 0 ? (
                                    propertyData.assignedProperties.map((property, index) => (
                                        <div key={index} className={styles.propertyItem}>
                                            <div className={styles.propertyNumber}>
                                                <span>{index + 1}</span>
                                            </div>
                                            <div className={styles.propertyContent}>
                                                <span className={styles.propertyName}>{property}</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className={styles.noProperties}>
                                        <div className={styles.noPropertiesIcon}>🏢</div>
                                        <h5>No Properties Assigned</h5>
                                        <p>This staff member hasn&apos;t been assigned to any properties yet.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }
            onCloseModal={onClose}
            shouldCloseOnOverLay={false}
        />
    );
};

export default PropertiesModal;
